import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import './i18n';
import { FuuzeTheme, GlobalStyle, QueriesContext } from '@fuuze/shared';
import { setUseWhatChange } from '@simbathesailor/use-what-changed';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { PrimeReactProvider } from 'primereact/api';
import { router } from './routes';
import { fetchService, queryClient } from './singletons';
import './styles/global.css';
import '@fuuze/shared/styles/global';

setUseWhatChange(import.meta.env.DEV);

export default function App() {
  // usePerformActionBeforeNavigatingAway();
  return (
    <PostHogProvider client={posthog}>
      <QueriesContext.Provider value={fetchService}>
        <QueryClientProvider client={queryClient}>
          <PrimeReactProvider>
            <ThemeProvider theme={FuuzeTheme}>
              <GlobalStyle />
              <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' />
              <RouterProvider future={{ v7_startTransition: true }} router={router} />
            </ThemeProvider>
          </PrimeReactProvider>
        </QueryClientProvider>
      </QueriesContext.Provider>
    </PostHogProvider>
  );
}
